module.exports = __webpack_public_path__ + "img/onthego.fdce1205.png";